function PopoverTarget() {
  return null;
}

PopoverTarget.displayName = 'PopoverTarget';

export default PopoverTarget;



// WEBPACK FOOTER //
// ./elements/Popover/PopoverTarget.js